import { debounce } from 'lodash';
import { useMemo, useState } from 'react';
import { Space } from 'api/space';

export interface SpaceT extends Space {
  hidden?: boolean;
}

export const useSidebarData = ({
  projectSpaces,
}: {
  projectSpaces: Space[];
}) => {
  const [searchInput, setSearchInput] = useState<string>();

  const onSearch = (e: string) => {
    setSearchInput(e?.trim());
  };

  const debouncedonSearch = useMemo(() => debounce(onSearch, 500), []);

  const filteredSpaces: SpaceT[] = useMemo(() => {
    if (!searchInput) {
      return projectSpaces;
    }

    return projectSpaces.map((space) => {
      const updatedSpaceTabs = space?.spaceTabs.filter((spaceTab) => {
        if (
          spaceTab?.spaceTabTitle
            ?.toLowerCase()
            .includes(searchInput.toLowerCase())
        ) {
          return spaceTab;
        }

        return false;
      });

      if (updatedSpaceTabs.length) {
        return {
          ...space,
          spaceTabs: updatedSpaceTabs,
        };
      }

      return {
        ...space,
        spaceTabs: [],
        hidden: true,
      };
    });
  }, [searchInput, projectSpaces]);

  const privateSpaces = useMemo(
    () => filteredSpaces.filter((space) => space.private),
    [filteredSpaces],
  );
  const sharedSpaces = useMemo(
    () => filteredSpaces.filter((space) => !space.private),
    [filteredSpaces],
  );

  return {
    onSearch: debouncedonSearch,
    privateSpaces,
    sharedSpaces,
  };
};
